module.exports = __webpack_public_path__ + "img/coupon-popup-item-use-hen.png.6f06a0dc.png";